export default "__VITE_ASSET__803a402b__"